import React, { useEffect } from 'react'
import { usePardotCookieAssociation } from './usePardotCookieAssociation'

/**
 * PardotCookieAssociation handles the association of Pardot prospect
 * with the user by sending second request via iframe.
 */
export const PardotCookieAssociation: React.FC = () => {
  const { url, cleanup } = usePardotCookieAssociation()

  useEffect(() => {
    return cleanup
  }, [cleanup])

  if (!url) {
    return null
  }

  return <iframe src={url} style={{ display: 'none' }} onLoad={cleanup} onError={cleanup} />
}
